import { render, staticRenderFns } from "./BaseConfirmReplaceModal.vue?vue&type=template&id=21c083d5&scoped=true"
import script from "./BaseConfirmReplaceModal.vue?vue&type=script&lang=js"
export * from "./BaseConfirmReplaceModal.vue?vue&type=script&lang=js"
import style0 from "./BaseConfirmReplaceModal.vue?vue&type=style&index=0&id=21c083d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c083d5",
  null
  
)

export default component.exports